import { Navigate } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';
import { useHasPermission } from '../features/auth/useAuth';

interface Props {
  permissions: string[];
  children: React.ReactNode;
  mode?: 'redirect' | 'message';
}

export function RequirePermission({ permissions, children, mode = 'redirect' }: Props) {
  const ok = useHasPermission(...permissions);
  if (ok) return <>{children}</>;
  if (mode === 'redirect') return <Navigate to="/dashboard" replace />;
  return (
    <div className="flex h-full items-center justify-center p-12">
      <div className="max-w-md rounded-lg border border-neutral-200 bg-white p-8 text-center shadow-sm">
        <ShieldAlert className="mx-auto mb-3 h-10 w-10 text-neutral-300" aria-hidden="true" />
        <h3 className="text-lg font-bold text-neutral-800">Sin permisos</h3>
        <p className="mt-2 text-sm text-neutral-500">No tienes permisos para ver esta pagina.</p>
      </div>
    </div>
  );
}
